/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Seconds_LabelInputs */



/**
* | output |
* | --- |
* | "Seconds" |
*
* @param {Summary_Seconds_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_seconds_label = /** @type {((inputs?: Summary_Seconds_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Seconds_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Secondes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekunden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Secondi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Секунды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Artículos de segunda clase")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("秒")
	if (locale === "ja") return /** @type {LocalizedString} */ ("秒")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेकंड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Segundos")
	return /** @type {LocalizedString} */ ("Seconds")
});